import styled, { css } from 'styled-components'

export const Map = styled.div`
  width: 100%;
  height: 500px;
`
